/**
 * Kí hiệu tiền tệ
 */
export default {
  NormalVND: 'đ',
  UpperCaseVND: 'Đ',
  USD: '$',
  None: 0,
};
